import React from 'react';

import PageLayout from '@magoosh/layouts/page';
import { NavigationItemProps } from '@magoosh/layouts/types';

import LegacyPaymentsRegistrationForm from '@payments/legacy_payments/organisms/forms/registration';
import { SubscriptionFormProps } from '@payments/legacy_payments/types';
import RegistrationForm from '@payments/organisms/forms/registration';
import { PurchaseAgreementFormProps } from '@payments/types';

// LegacyPayments: the two flows describe what is being bought differently - an agreement, or the
// subscription itself - so the page takes whichever of the two props Rails built and hands it to
// the matching form. `purchaseAgreements` is the feature flag, resolved server side.
type Props = {
  examName: string;
  // Already rendered and sanitized by the flashes partial, the way the marketing pack hands its
  // own notices to PageLayout
  flashes?: string;
  navigationItems: {
    items: NavigationItemProps[];
    supplementalItems: NavigationItemProps[];
  };
} & (
  | ({ purchaseAgreements: true } & PurchaseAgreementFormProps)
  | ({ purchaseAgreements: false } & SubscriptionFormProps)
);

const Register: React.FC<Props> = (props) => {
  return (
    <PageLayout dashedBorder examName={props.examName} navigationItems={props.navigationItems}>
      <div>
        {props.flashes && <div dangerouslySetInnerHTML={{ __html: props.flashes }} />}

        {props.purchaseAgreements === true ? (
          <RegistrationForm
            isEuUser={props.isEuUser}
            purchaseAgreement={props.purchaseAgreement}
            signedIn={props.signedIn}
          />
        ) : (
          <LegacyPaymentsRegistrationForm
            isEuUser={props.isEuUser}
            order={props.order}
            signedIn={props.signedIn}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default Register;
